
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"19","height":"23","viewBox":"0 0 19 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"2","y":"5","width":"6","height":"6","rx":"1","fill":"#fff"}}),_c('rect',{attrs:{"x":"2","y":"14","width":"6","height":"6","rx":"1","fill":"#fff"}}),_c('rect',{attrs:{"x":"11","y":"5","width":"6","height":"6","rx":"1","fill":"#fff"}}),_c('rect',{attrs:{"x":"11","y":"14","width":"6","height":"6","rx":"1","fill":"#fff"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Lead/ToggleBtn/assets/grid.svg
// module id = 4YiL
// module chunks = 1